module.exports = __webpack_public_path__ + "static/media/waze.4c4821e5.png";